// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import ClockCircleOutlinedSvg from "@ant-design/icons-svg/lib/asn/ClockCircleOutlined";
import AntdIcon from "../components/AntdIcon";
const ClockCircleOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: ClockCircleOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    ClockCircleOutlined.displayName = "ClockCircleOutlined";
}
export default /*#__PURE__*/ React.forwardRef(ClockCircleOutlined);
